export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filters.vue?vue&type=template&id=ff2c2c24&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/filters.vue?vue&type=template&id=ff2c2c24&scoped=true
// module id = 2458
// module chunks = 31